module.exports = __webpack_public_path__ + "media/images/sp/staffs/mv_photographer@2x-d9c68cfddd207347438b9405b24b73b4.webp";